import QRCode from "qrcode";
import api from "./api";
import { ticketStyles, openAndPrint } from "./ticket";
import { connectQz, printHtml } from "./qz";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const money = (n) => `$${(Number(n) || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const meta = (k, v) => `<div class="meta"><span>${k}</span><span>${esc(v || "—")}</span></div>`;
const FORMAS = { "01": "Efectivo", "02": "Cheque", "03": "Transferencia", "04": "Tarjeta de crédito", "28": "Tarjeta de débito", "99": "Por definir" };

function qrSvg(text) {
  try {
    const q = QRCode.create(text, { errorCorrectionLevel: "M" });
    const n = q.modules.size, m = 2;
    let d = "";
    for (let y = 0; y < n; y += 1) for (let x = 0; x < n; x += 1) if (q.modules.get(x, y)) d += `M${x + m} ${y + m}h1v1h-1z`;
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n + 2 * m} ${n + 2 * m}" shape-rendering="crispEdges" class="qr"><rect width="100%" height="100%" fill="#fff"/><path d="${d}" fill="#000"/></svg>`;
  } catch (e) { return ""; }
}

export function satVerifyUrl(inv) {
  const tt = (Number(inv.total) || 0).toFixed(6).padStart(17, "0");
  return `https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?id=${inv.uuid}&re=${encodeURIComponent(inv.issuer?.rfc || "")}&rr=${encodeURIComponent(inv.receiver?.Rfc || "")}&tt=${tt}&fe=${encodeURIComponent(inv.stamp?.seal_tail || "")}`;
}

export function buildInvoiceTicketHtml(s, inv) {
  const items = (inv.items || []).map((i) => `<div class="row"><span>${esc(i.Quantity)} ${esc(i.Description)}</span><span>${money(i.Total)}</span></div>`).join("");
  const body = `<div class="center">
      ${s.logo_url ? `<img src="${s.logo_url}" style="max-height:60px;max-width:70%;object-fit:contain"/>` : ""}
      <div class="biz">${esc(s.business_name || inv.issuer?.name || "")}</div>
      <div class="muted">${esc(inv.issuer?.name || "")}</div>
      <div class="muted">RFC ${esc(inv.issuer?.rfc || "")} · Régimen ${esc(inv.issuer?.regime || "")}</div>
      <div class="muted">Lugar de expedición CP ${esc(inv.issuer?.zip || "")}</div>
    </div>
    <hr class="solid"/>
    <div class="doc">FACTURA ${esc(inv.serie)}-${esc(inv.folio)}</div>
    <div class="center muted">CFDI 4.0 · Ingreso${inv.env === "sandbox" ? " · PRUEBAS SIN VALIDEZ" : ""}</div>
    <hr/>
    ${meta("Fecha", new Date(inv.stamp?.date || inv.created_at).toLocaleString("es-MX"))}
    ${meta("Receptor", inv.receiver?.Name)}
    ${meta("RFC", inv.receiver?.Rfc)}
    ${meta("Uso CFDI", inv.use || inv.receiver?.CfdiUse)}
    ${meta("Forma de pago", `${inv.payment_form} ${FORMAS[inv.payment_form] || ""}`)}
    ${meta("Método", "PUE · Una sola exhibición")}
    <hr/>
    ${items}
    <hr/>
    <div class="row"><span>Subtotal</span><span>${money(inv.subtotal)}</span></div>
    <div class="row"><span>Impuestos</span><span>${money(inv.total - inv.subtotal)}</span></div>
    <div class="row" style="font-weight:900;font-size:1.25em"><span>TOTAL</span><span>${money(inv.total)}</span></div>
    <hr/>
    <div class="center muted">Folio fiscal (UUID)</div>
    <div class="center" style="font-size:.8em;word-break:break-all">${esc(inv.uuid || "")}</div>
    ${inv.stamp?.sat_cert ? `<div class="center muted" style="font-size:.75em">No. certificado SAT ${esc(inv.stamp.sat_cert)}</div>` : ""}
    <div class="qrbox">${qrSvg(satVerifyUrl(inv))}<div class="qrurl">Verifica en el SAT</div></div>
    <div class="foot">Este documento es una representación impresa de un CFDI</div>`;
  return `<html><head><meta charset="utf-8"/><style>${ticketStyles(s.ticket_size || "80", s.ticket_font_size || "mediano")}</style></head><body>${body}</body></html>`;
}

export async function printInvoiceTicket(inv) {
  const [{ data: s }, full] = await Promise.all([
    api.get("/settings"),
    inv.items ? Promise.resolve(inv) : api.get(`/invoicing/invoices/${inv.id}`).then((r) => r.data),
  ]);
  const html = buildInvoiceTicketHtml(s || {}, full);
  const printer = (s?.printer_caja || "").trim();
  if (printer) {
    try { await connectQz(); await printHtml(printer, html, s.ticket_size || "80"); return; } catch (e) { /* fallback al navegador */ }
  }
  openAndPrint(html);
}
